// ラベル
export const LABELS = {
  TITLE: "事業者情報",
  SEARCH: "法人番号検索",
  CORP_CODE: "事業者コード",
  CORP_NUMBER: "法人番号",
  CORP_COMPANY_CODE: "事業者コード",
  CORP_NAME: "事業者名",
  CORP_KANA: "事業者名カナ",
  CORP_SUB_TITLE: "所在地情報",
  CORP_POSTAL_CODE: "郵便番号",
  CORP_PREFECTURE: "都道府県",
  CORP_MUNICIPALITY: "市区町村",
  CORP_TOWN: "大字・町名",
  CORP_CHOME: "字・丁目",
  CORP_BANCHI: "番地",
  CORP_BUILDING_NAME: "建物名",
  CORP_TEL: "電話番号",
  LAST_UPDATER: "最終更新者:",
  LAST_UPDATING_TIME: "最終更新日時:",
  POSTAL_CODE_SEARCH: "郵便番号検索",
  ADDRESS1: "住所",
  ADDRESS1_KANA: "住所カナ",
  ADDRESS2: "住所（その他）",
  ADDRESS2_KANA: "住所カナ（その他）",
} as const;

// プレースホルダーの内容
export const PLACE_HOLDERS = {
  CORP_NAME: "（記入例）株式会社NTTドコモ",
  CORP_KANA: "（記入例）カブシキガイシャエヌティティドコモ",
  CORP_POSTAL_CODE: "（記入例）1006150",
  CORP_BANCHI: "（記入例）1-1",
  CORP_BUILDING_NAME: "（記入例）山王パークタワー",
  CORP_TEL: "（記入例）0351561111",
} as const;
